import styled from 'styled-components';

import { ThemeProp } from '~/theme/Themes';

export const FilterButton = styled.button`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.s};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c200};
  position: relative;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  padding: 0.375rem 0.75rem;
  gap: 0.5rem;
  display: flex;
  align-items: center;

  &:disabled {
    background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.c050};
    color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    height: 2rem;
    padding: 0.375rem 0.35rem;
    & > svg {
      width: 1.25rem;
    }
  }
`;
